<template>
    <v-banner single-line sticky>
        <div class="d-none d-sm-block">
            <v-row>
                <v-col cols="1" class="text-center">
                    <v-menu right bottom>
                        <template
                            v-if="
                                status != 'CloseCase' &&
                                    status != 'ViewCloseCase'
                            "
                            v-slot:activator="{ on }"
                        >
                            <v-btn icon v-on="on">
                                <v-icon>mdi-link-variant</v-icon>
                            </v-btn>
                        </template>

                        <v-list dense no-action>
                            <v-list-item
                                class="pl-5"
                                link
                                v-for="(item, n) in lists"
                                :key="n"
                                @click="gotoLink(item.eleId)"
                            >
                                <v-list-item-title>{{
                                    item.eleName
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>

                <v-col sm="11" md="6">
                    <h3 class="pb-2">
                        {{ detailcase.project_name }} | {{ detailcase.case_id }}
                        <span
                            class="ml-1 primary--text"
                            v-if="detailcase.wonumber"
                        >
                            {{ detailcase.wonumber }}
                        </span>
                        <view-cdax
                            :caseid="detailcase.case_id"
                            v-if="
                                detailcase.project_name == 'CDAX' ||
                                    detailcase.project_name == 'S-Print'
                            "
                            class="ml-3"
                        />
                    </h3>
                    <h3 class="pb-2 text-wrap">{{ detailcase.case_title }}</h3>
                    <!-- <v-btn
          v-if="checkcondition === false"
          small
          v-on="on"
          tile
          dark
          class="mr-10"
          color="warning"
          @click="$emit('editcase-click')"
        >
          <v-icon small left>mdi-lead-pencil</v-icon>Edit Case
        </v-btn> -->

                    <v-row v-if="checkcondition" class="pl-3">
                        <v-btn
                            v-if="
                                detailcase.main_status_name == 'Incomplete' &&
                                    detailcase.sub_status_name !=
                                        'Waiting Quotation' &&
                                    detailcase.sub_status_name !=
                                        'Pickup Unit' &&
                                    detailcase.sub_status_name !=
                                        'Pickup Monitor'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="mr-10"
                            color="success"
                            :to="
                                '/Project/' +
                                    team +
                                    '/SubCase/' +
                                    detailcase.maincase_id
                            "
                        >
                            <v-icon small left>mdi-plus</v-icon>Open New Sub
                        </v-btn>
                        <!-- detailcase.main_status_name != 'Closed' && -->
                        <v-btn
                            v-if="
                                status != 'CloseCase' &&
                                    status != 'ViewCloseCase' &&
                                    detailcase.main_status_name != 'Cancel'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="orange darken-1 mr-4"
                            :to="
                                '/Project/' +
                                    team +
                                    '/EditCase/' +
                                    detailcase.maincase_id +
                                    '/' +
                                    detailcase.subcase
                            "
                        >
                            <v-icon small left>mdi-pencil</v-icon>Edit Case
                        </v-btn>

                        <v-btn
                            v-if="
                                (detailcase.main_status_name != 'Closed' &&
                                    detailcase.main_status_name !=
                                        'Pending CE' &&
                                    detailcase.main_status_name !=
                                        'Wait Part') ||
                                    (detailcase.main_status_name == 'Closed' &&
                                        team_name == 'NONHP')
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="pink darken-1 mr-4"
                            @click="
                                $emit(
                                    'returncasetoce-click',
                                    detailcase.case_id
                                )
                            "
                        >
                            <v-icon small left>mdi-arrow-left</v-icon>Return
                            Case To CE
                        </v-btn>

                        <v-btn
                            v-if="
                                (team_name == detailcase.team_name &&
                                    team_name == 'IPG') ||
                                    team_name == 'PSG' ||
                                    team_name == 'SUPPORTUC'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="gray darken-1 mr-4"
                            @click="$emit('transferzone-click')"
                        >
                            <v-icon small left>mdi-transfer</v-icon>Transfer
                            Zone
                        </v-btn>
                        <v-btn
                            v-if="
                                status != 'CloseCase' &&
                                    status != 'ViewCloseCase'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="blue mr-4"
                            @click="$emit('custcancel-click')"
                        >
                            <v-icon small left>mdi-account</v-icon>Cust. Cancel
                        </v-btn>

                        <v-btn
                            v-if="
                                status != 'CloseCase' &&
                                    status != 'ViewCloseCase' &&
                                    detailcase.subcase != 1 &&
                                    (detailcase.main_status_name ==
                                        'Wait Part' ||
                                        detailcase.main_status_name ==
                                            'Pending CE')
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="red accent-1 mr-4"
                            @click="$emit('delsub-click')"
                        >
                            <v-icon small left>mdi-delete-circle</v-icon>Delete
                            last sub
                        </v-btn>
                        <v-btn
                            v-if="
                                status == 'ViewDetail' &&
                                    status != 'CloseCase' &&
                                    status != 'ViewCloseCase' &&
                                    detailcase.main_status_name != 'Closed' &&
                                    detailcase.main_status_name != 'Cancel' &&
                                    role_name != 'Inventory Admin'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="red darken-1 mr-4"
                            @click="$emit('voidcase-click')"
                        >
                            <v-icon small left>mdi-delete-circle</v-icon>Void
                            Case
                        </v-btn>

                        <v-btn
                            v-if="
                                detailcase.pass_backorder == 'Y' &&
                                    detailcase.main_status_name != 'Closed' &&
                                    detailcase.main_status_name != 'Cancel'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="blue darken-2 mr-4"
                            @click="$emit('backorder-click')"
                        >
                            <v-icon small left>mdi-cursor-move</v-icon>Return
                            BackOrder
                        </v-btn>
                        <v-btn
                            v-if="
                                status == 'CloseCase' ||
                                    status == 'ViewCloseCase' ||
                                    detailcase.main_status_name ==
                                        'Waiting Happy Call' ||
                                    detailcase.main_status_name ==
                                        'Pending Close' ||
                                    detailcase.main_status_name ==
                                        'Waiting Cust. Pickup' ||
                                    (detailcase.main_status_name == 'Closed' &&
                                        (role_name == 'Manager' ||
                                            role_name == 'Senior' ||
                                            role_name == 'Project Manager' ||
                                            team_name == 'NONHP'))
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="red darken-1 ml-10"
                            @click="$emit('changeincomplete-click')"
                        >
                            <v-icon small left>mdi-lead-pencil</v-icon>Change
                            Incomplete
                        </v-btn>

                        <v-btn
                            v-if="detailcase.main_status_name == 'Incomplete'"
                            small
                            v-on="on"
                            tile
                            dark
                            class="red darken-1 ml-10"
                            @click="$emit('changecomplete-click')"
                        >
                            <v-icon small left>mdi-lead-pencil</v-icon>Change
                            Complete
                        </v-btn>
                        <v-btn
                            v-if="
                                detailcase.main_status_name == 'Cust. Checking'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="green darken-1 ml-10"
                            @click="$emit('changeincompletecomplete-click')"
                        >
                            <v-icon small left>mdi-lead-pencil</v-icon>Update
                            Status
                        </v-btn>

                        <v-btn
                            v-if="
                                detailcase.main_status_id == 2 &&
                                    detailcase.sub_status_name ==
                                        'Assigned' &&
                                    detailcase.team_name == 'ODM'
                            "
                            small
                            v-on="on"
                            tile
                            dark
                            class="teal darken-1 ml-10"
                            @click="dialog_skipce = true"
                        >
                            <v-icon small left
                                >mdi-skip-next-circle-outline</v-icon
                            >Skip CE Close Case
                        </v-btn>
                    </v-row>
                </v-col>

                <!-- <v-col sm="12" md="3" class="text-center" v-if="detailcase.RequestedDateTime_x"> -->
                <v-col
                    sm="12"
                    md="3"
                    class="text-center"
                    v-if="detailcase.RequestedDateTime_x"
                >
                    <v-card color="#385F73" dark>
                        <!-- <v-card-title class="text-h1">
                            <span class="orange--text">
                                Guaranteed FixTime
                            </span>
                            {{ detailcase.GuaranteedFixTime_x }}
                        </v-card-title> -->

                        <v-card-title class="text-h1">
                            <span class="orange--text">
                                Request Date Time
                            </span>
                            {{ detailcase.RequestedDateTime_x }}
                        </v-card-title>
                        <div class="fix-x-01">
                            <span :class="num_d"> {{ dateX }}</span>
                        </div>
                    </v-card>
                </v-col>

                <v-col
                    sm="12"
                    :md="detailcase.RequestedDateTime_x ? 2 : 5"
                    class="text-right"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                :color="detailcase.main_status_color"
                                fab
                                dark
                                v-on="on"
                                x-small
                                elevation="0"
                            >
                                <v-icon small>{{
                                    detailcase.main_status_icon
                                }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ detailcase.main_status_name }}</span>
                    </v-tooltip>
                    <span class="ml-2 font-weight-medium">
                        {{ detailcase.sub_status_name }}
                    </span>
                    <p
                        v-if="detailcase.project_name == 'CDAX'"
                        class="mt-2 font-weight-medium"
                    >
                        CDAX : {{ detailcase.status_name }}
                    </p>

                    <v-btn
                        rounded
                        small
                        @click="open_log_eeg(detailcase.subcase_id)"
                        v-if="detailcase.show_ismart == 'Y'"
                    >
                        <span class="orange--text">EEG</span>
                        <span class="primary--text ml-1">STATUS LOG</span>
                    </v-btn>
                    <br />
                    <v-btn
                        small
                        rounded
                        color="amber"
                        class="mt-2"
                        v-if="chk_btn_ph > 0 && detailcase.case_status_id == 2"
                        @click="$emit('changebackorder-click')"
                    >
                        <span>Change BackOrder</span>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="checkcondition">
                <v-col v-if="status == 'CloseCase'" sm="12" md="2" lg="2">
                    <!-- v-if="detailcase.show_ismart == 'N' && detailcase.skip_ismart != 'N'" -->
                    <!-- :disabled=" detailcase.show_ismart == 'Y' && detailcase.skip_ismart == 'N' && detailcase.project_name == 'CDAX'" -->
                    <v-btn
                        small
                        v-on="on"
                        tile
                        dark
                        class="red darken-1 ml-10"
                        @click="$emit('closecase-click')"
                    >
                        <v-icon small left>mdi-close-circle</v-icon>Close Case
                    </v-btn>
                </v-col>
                <v-col
                    v-if="status == 'CloseCase' || status == 'ViewCloseCase'"
                    sm="12"
                    md="2"
                    lg="2"
                >
                    <v-btn
                        small
                        v-on="on"
                        tile
                        dark
                        class="red darken-1 ml-10"
                        @click="$emit('rejectcase-click')"
                    >
                        <v-icon small left>mdi-close-circle</v-icon>Reject Case
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div class="d-sm-none">
            <v-row>
                <!-- <v-col cols="1" class="text-center"> </v-col> -->
                <v-col sm="12" md="7">
                    <h3 class="pb-2" style="font-size: 13px">
                        {{ detailcase.project_name }} | {{ detailcase.case_id }}
                        <v-menu right bottom>
                            <template
                                v-if="
                                    status != 'CloseCase' &&
                                        status != 'ViewCloseCase'
                                "
                                v-slot:activator="{ on }"
                            >
                                <v-btn icon v-on="on">
                                    <v-icon>mdi-link-variant</v-icon>
                                </v-btn>
                            </template>

                            <v-list dense no-action>
                                <v-list-item
                                    class="pl-5"
                                    link
                                    v-for="(item, n) in lists"
                                    :key="n"
                                    @click="gotoLink(item.eleId)"
                                >
                                    <v-list-item-title
                                        style="font-size: 12px"
                                        >{{ item.eleName }}</v-list-item-title
                                    >
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </h3>
                    <h3 class="pb-2 text-wrap" style="font-size: 13px">
                        {{ detailcase.case_title }}
                    </h3>
                    <!-- <v-btn
          v-if="checkcondition === false"
          small
          v-on="on"
          tile
          dark
          class="mr-10"
          color="warning"
          @click="$emit('editcase-click')"
        >
          <v-icon small left>mdi-lead-pencil</v-icon>Edit Case
        </v-btn> -->
                    <v-row align="center" v-if="checkcondition">
                        <v-col class="d-flex" cols="12" sm="6">
                            <v-select
                                @input="
                                    selectaction(
                                        select_action,
                                        detailcase.case_id,
                                        team,
                                        detailcase.maincase_id,
                                        detailcase.subcase
                                    )
                                "
                                :items="actions"
                                v-model="select_action"
                                label="Actions"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <!-- <v-row v-if="checkcondition" class="pl-3"> -->
                    <!-- <v-btn
              v-if="
                detailcase.main_status_name == 'Incomplete' &&
                  detailcase.sub_status_name != 'Waiting Quotation' &&
                  detailcase.sub_status_name != 'Pickup Unit' &&
                  detailcase.sub_status_name != 'Pickup Monitor'
              "
              small
              v-on="on"
              tile
              dark
              class="mr-10"
              color="success"
              :to="'/Project/' + team + '/SubCase/' + detailcase.maincase_id"
            >
              <v-icon small left>mdi-plus</v-icon>Open New Sub
            </v-btn>
            <v-btn
              v-if="
                status != 'CloseCase' &&
                  status != 'ViewCloseCase' &&
                  detailcase.main_status_name != 'Closed' &&
                  detailcase.main_status_name != 'Cancel'
              "
              small
              v-on="on"
              tile
              dark
              class="orange darken-1 mr-4"
              :to="
                '/Project/' +
                  team +
                  '/EditCase/' +
                  detailcase.maincase_id +
                  '/' +
                  detailcase.subcase
              "
            >
              <v-icon small left>mdi-pencil</v-icon>Edit Case
            </v-btn>
            <v-btn
              v-if="
                (detailcase.main_status_name != 'Closed' &&
                  detailcase.main_status_name != 'Pending CE' &&
                  detailcase.main_status_name != 'Wait Part') ||
                  (detailcase.main_status_name == 'Closed' &&
                    team_name == 'NONHP')
              "
              small
              v-on="on"
              tile
              dark
              class="pink darken-1 mr-4"
              @click="$emit('returncasetoce-click', detailcase.case_id)"
            >
              <v-icon small left>mdi-arrow-left</v-icon>Return Case To CE
            </v-btn>
            <v-btn
              v-if="
                (team_name == detailcase.team_name && team_name == 'IPG') ||
                  team_name == 'PSG' ||
                  team_name == 'SUPPORTUC'
              "
              small
              v-on="on"
              tile
              dark
              class="gray darken-1 mr-4"
              @click="$emit('transferzone-click')"
            >
              <v-icon small left>mdi-transfer</v-icon>Transfer Zone
            </v-btn>
            <v-btn
              v-if="
                status != 'CloseCase' &&
                  status != 'ViewCloseCase' &&
                  detailcase.subcase != 1 &&
                  (detailcase.main_status_name == 'Wait Part' ||
                    detailcase.main_status_name == 'Pending CE')
              "
              small
              v-on="on"
              tile
              dark
              class="red accent-1 mr-4"
              @click="$emit('delsub-click')"
            >
              <v-icon small left>mdi-delete-circle</v-icon>Delete last sub
            </v-btn>
            <v-btn
              v-if="
                status == 'ViewDetail' &&
                  status != 'CloseCase' &&
                  status != 'ViewCloseCase' &&
                  detailcase.main_status_name != 'Closed' &&
                  detailcase.main_status_name != 'Cancel'
              "
              small
              v-on="on"
              tile
              dark
              class="red darken-1 mr-4"
              @click="$emit('voidcase-click')"
            >
              <v-icon small left>mdi-delete-circle</v-icon>Void Case
            </v-btn>

            <v-btn
              v-if="
                detailcase.pass_backorder == 'Y' &&
                  detailcase.main_status_name != 'Closed' &&
                  detailcase.main_status_name != 'Cancel'
              "
              small
              v-on="on"
              tile
              dark
              class="blue darken-2 mr-4"
              @click="$emit('backorder-click')"
            >
              <v-icon small left>mdi-cursor-move</v-icon>Return BackOrder
            </v-btn> -->

                    <v-row>
                        <v-col>
                            <v-btn
                                color="orange"
                                fab
                                dark
                                x-small
                                elevation="0"
                            >
                                <v-icon small style="font-size: 15px">{{
                                    detailcase.main_status_icon
                                }}</v-icon>
                            </v-btn>
                            <span
                                class="ml-2 font-weight-medium"
                                style="font-size: 15px"
                            >
                                {{ detailcase.main_status_name }}
                            </span>

                            <span
                                class="ml-2 font-weight-medium"
                                style="font-size: 15px"
                                v-if="detailcase.project_name == 'CDAX'"
                            >
                                CDAX : {{ detailcase.status_name }}
                            </span></v-col
                        >
                    </v-row>
                    <!-- </v-row> -->
                </v-col>
            </v-row>
            <!-- <v-row v-if="checkcondition">
        <v-col v-if="status == 'CloseCase'" sm="12" md="2" lg="2">
          <v-btn
            small
            v-on="on"
            tile
            dark
            class="red darken-1 ml-10"
            @click="$emit('closecase-click')"
          >
            <v-icon small left>mdi-close-circle</v-icon>Close Case
          </v-btn>
        </v-col>
        <v-col
          v-if="status == 'CloseCase' || status == 'ViewCloseCase'"
          sm="12"
          md="2"
          lg="2"
        >
          <v-btn
            small
            v-on="on"
            tile
            dark
            class="red darken-1 ml-10"
            @click="$emit('rejectcase-click')"
          >
            <v-icon small left>mdi-close-circle</v-icon>Reject Case
          </v-btn>
        </v-col>
        <v-col
          v-if="
            status == 'CloseCase' ||
              status == 'ViewCloseCase' ||
              detailcase.main_status_name == 'Waiting Happy Call' ||
              detailcase.main_status_name == 'Pending Close' ||
              detailcase.main_status_name == 'Waiting Cust. Pickup'
          "
          sm="12"
          md="2"
          lg="2"
        >
          <v-btn
            small
            v-on="on"
            tile
            dark
            class="red darken-1 ml-10"
            @click="$emit('changeincomplete-click')"
          >
            <v-icon small left>mdi-lead-pencil</v-icon>Change Incomplete
          </v-btn>
        </v-col>
        <v-col
          v-if="detailcase.main_status_name == 'Incomplete'"
          sm="12"
          md="2"
          lg="2"
        >
          <v-btn
            small
            v-on="on"
            tile
            dark
            class="red darken-1 ml-10"
            @click="$emit('changecomplete-click')"
          >
            <v-icon small left>mdi-lead-pencil</v-icon>Change Complete
          </v-btn>
        </v-col>
      </v-row> -->
        </div>

        <v-row justify="center">
            <v-dialog v-model="dialog_eeg" persistent max-width="1100px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">EEG STATUS LOG</span>
                        <v-btn
                            fab
                            x-small
                            class="ml-1"
                            @click="get_log_eeg(detailcase.subcase_id)"
                        >
                            <v-icon color="primary">mdi-refresh</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog_eeg = false"
                        >
                            Close
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        Partner Status
                                                    </th>
                                                    <th class="text-center">
                                                        Status Code
                                                    </th>
                                                    <th class="text-center">
                                                        Created At
                                                    </th>
                                                    <th class="text-center">
                                                        Active EEG
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_eeg"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        {{ index + 1 }}.
                                                    </td>
                                                    <td>
                                                        {{ row.partner_status }}
                                                        <br
                                                            v-if="
                                                                row.status_code !=
                                                                    200 &&
                                                                    row.status_code !=
                                                                        202
                                                            "
                                                        />
                                                        <span
                                                            class="red--text"
                                                            v-if="
                                                                row.status_code !=
                                                                    200 &&
                                                                    row.status_code !=
                                                                        202
                                                            "
                                                        >
                                                            {{ row.status_log }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span
                                                            :class="
                                                                row.status_code !=
                                                                    200 &&
                                                                row.status_code !=
                                                                    202
                                                                    ? 'red--text'
                                                                    : ''
                                                            "
                                                        >
                                                            {{
                                                                row.status_code
                                                            }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_at }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-btn
                                                            fab
                                                            x-small
                                                            color="amber"
                                                            v-if="
                                                                row.status_code !=
                                                                    200 &&
                                                                    row.status_code !=
                                                                        202
                                                            "
                                                        >
                                                            <v-icon>
                                                                mdi-chevron-right
                                                            </v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <br />
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                        >
                            Close
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <skip-ce-close-case
            v-model="dialog_skipce"
            :detailcase="detailcase"
            @saved="$emit('skipceclosecase-saved')"
        />

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-banner>
</template>
<style scoped></style>
<script>
import axios from "axios"
import ViewCdax from "../../../components/ViewCdax"
import SkipCeCloseCase from "./SkipCeCloseCase"

export default {
    components: {
        "view-cdax": ViewCdax,
        "skip-ce-close-case": SkipCeCloseCase,
    },
    props: ["detailcase", "team", "status"],

    data() {
        return {
            chk_btn_ph: 0,
            select_action: "",
            actions: [],

            options: {
                offset: 100,
            },
            lists: [
                {
                    eleId: "#case",
                    eleName: "Case Information",
                },
                {
                    eleId: "#product",
                    eleName: "Products Information",
                },
                {
                    eleId: "#customer",
                    eleName: "Customer Information",
                },
                {
                    eleId: "#services",
                    eleName: "Services Information",
                },
                {
                    eleId: "#lognote",
                    eleName: "Log Note",
                },
                {
                    eleId: "#parts",
                    eleName: "Parts Information",
                },
                {
                    eleId: "#attach",
                    eleName: "Attachments",
                },
                {
                    eleId: "#happycall",
                    eleName: "Happy Call",
                },
                {
                    eleId: "#performance",
                    eleName: "Performance",
                },
            ],
            role_name: localStorage.role_name,
            team_name: localStorage.team_name,
            tk: { headers: { Authorization: "Bearer " + localStorage.token } },
            dialog_eeg: false,
            dialog_skipce: false,
            dialog_loading: false,
            data_eeg: [],
            dateX: null,
            num_d: 0,
        }
    },
    beforeUpdate() {
        console.log(this.detailcase, this.team, "-detailcase/team debug")
        if (
            this.detailcase.main_status_name == "Incomplete" &&
            this.detailcase.sub_status_name != "Waiting Quotation" &&
            this.detailcase.sub_status_name != "Pickup Unit" &&
            this.detailcase.sub_status_name != "Pickup Monitor"
        ) {
            this.actions.push("Open New Sub")
        }
        if (
            this.status != "CloseCase" &&
            this.status != "ViewCloseCase" &&
            this.detailcase.main_status_name != "Cancel"
        ) {
            this.actions.push("Edit Case")
        }
        if (this.status != "CloseCase" && this.status != "ViewCloseCase") {
            this.actions.push("Cust. Cancel")
        }
        if (
            (this.detailcase.main_status_name != "Closed" &&
                this.detailcase.main_status_name != "Pending CE" &&
                this.detailcase.main_status_name != "Wait Part") ||
            (this.detailcase.main_status_name == "Closed" &&
                this.team_name == "NONHP")
        ) {
            this.actions.push("Return Case To CE")
        }
        if (
            (this.team_name == this.detailcase.team_name &&
                this.team_name == "IPG") ||
            this.team_name == "PSG" ||
            this.team_name == "SUPPORTUC"
        ) {
            this.actions.push("Transfer Zone")
        }
        if (
            this.status != "CloseCase" &&
            this.status != "ViewCloseCase" &&
            this.detailcase.subcase != 1 &&
            (this.detailcase.main_status_name == "Wait Part" ||
                this.detailcase.main_status_name == "Pending CE")
        ) {
            this.actions.push("Delete last sub")
        }
        if (
            this.status == "ViewDetail" &&
            this.status != "CloseCase" &&
            this.status != "ViewCloseCase" &&
            this.detailcase.main_status_name != "Closed" &&
            this.detailcase.main_status_name != "Cancel" &&
            this.role_name != "Inventory Admin"
        ) {
            this.actions.push("Void Case")
        }
        if (
            this.detailcase.pass_backorder == "Y" &&
            this.detailcase.main_status_name != "Closed" &&
            this.detailcase.main_status_name != "Cancel"
        ) {
            this.actions.push("Return BackOrder")
        }
        if (
            this.status == "CloseCase" ||
            this.status == "ViewCloseCase" ||
            this.detailcase.main_status_name == "Waiting Happy Call" ||
            this.detailcase.main_status_name == "Pending Close" ||
            this.detailcase.main_status_name == "Waiting Cust. Pickup" ||
            (this.detailcase.main_status_name == "Closed" &&
                (this.role_name == "Manager" ||
                    this.role_name == "Senior" ||
                    this.role_name == "Project Manager" ||
                    this.team_name == "NONHP"))
        ) {
            this.actions.push("Change Incomplete")
        }
        if (this.detailcase.main_status_name == "Incomplete") {
            this.actions.push("Change Complete")
        }
        if (this.status == "CloseCase") {
            this.actions.push("Close Case")
        }
        if (this.status == "CloseCase" || this.status == "ViewCloseCase") {
            this.actions.push("Reject Case")
        }
        if (this.detailcase.main_status_name == "Cust. Checking") {
            this.actions.push("Update Status")
        }
        if (
            this.detailcase.main_status_id == 2 &&
            this.detailcase.sub_status_name == "Assigned" &&
            this.detailcase.team_name == "ODM"
        ) {
            this.actions.push("Skip CE Close Case")
        }

        this.detailcase.parts.map((each, index) => {
            if (each.status == "Back Order") {
                this.chk_btn_ph += 1
            }
        })
    },
    created() {
        setInterval(this.getNow, 1000)
    },
    methods: {
        getNow: function() {
            let y1 = new Date(
                this.detailcase.RequestedDateTime
            ).toLocaleString("default", { year: "numeric" })
            let m1 = new Date(
                this.detailcase.RequestedDateTime
            ).toLocaleString("default", { month: "short" })
            let d1 = new Date(
                this.detailcase.RequestedDateTime
            ).toLocaleString("default", { day: "2-digit" })
            let hh = new Date(this.detailcase.RequestedDateTime).getHours()
            let mm = new Date(this.detailcase.RequestedDateTime).getMinutes()
            let ss = new Date(this.detailcase.RequestedDateTime).getSeconds()

            // let yy = y1 - 543

            let future = Date.parse(`${m1} ${d1}, ${y1} ${hh}:${mm}:${ss}`)
            let now = new Date()
            let diff = future - now

            let days = Math.floor(diff / (1000 * 60 * 60 * 24))
            let hours = Math.floor(diff / (1000 * 60 * 60))
            let mins = Math.floor(diff / (1000 * 60))
            let secs = Math.floor(diff / 1000)

            let d = days
            let h = hours - days * 24
            let m = mins - hours * 60
            let s = secs - mins * 60

            this.num_d = d <= 1 ? "fix-x-03" : "fix-x-02"
            if (d < 0) {
                this.dateX = `0d 0h 0m 0s`
            } else {
                this.dateX = `${d}d ${h}h ${m}m ${s}s`
            }
        },

        selectaction(action, caseid, team, maincase, subcase) {
            if (action == "Open New Sub") {
                if (window.location.hostname == "localhost") {
                    window.location.assign(
                        window.location.protocol +
                            "//localhost:" +
                            window.location.port +
                            "/project/" +
                            team +
                            "/SubCase/" +
                            maincase
                    )
                } else {
                    window.location.assign(
                        window.location.protocol +
                            "//" +
                            window.location.hostname +
                            "/project/" +
                            team +
                            "/SubCase/" +
                            maincase
                    )
                }
            } else if (action == "Edit Case") {
                if (window.location.hostname == "localhost") {
                    window.location.assign(
                        window.location.protocol +
                            "//localhost:" +
                            window.location.port +
                            "/project/" +
                            team +
                            "/EditCase/" +
                            maincase +
                            "/" +
                            subcase
                    )
                } else {
                    window.location.assign(
                        window.location.protocol +
                            "//" +
                            window.location.hostname +
                            "/project/" +
                            team +
                            "/EditCase/" +
                            maincase +
                            "/" +
                            subcase
                    )
                }
            } else if (action == "Return Case To CE") {
                this.$emit("returncasetoce-click", caseid)
            } else if (action == "Transfer Zone") {
                this.$emit("transferzone-click")
            } else if (action == "Cust. Cancel") {
                this.$emit("custcancel-click")
            } else if (action == "Delete last sub") {
                this.$emit("delsub-click")
            } else if (action == "Void Case") {
                this.$emit("voidcase-click")
            } else if (action == "Return BackOrder") {
                this.$emit("backorder-click")
            } else if (action == "Change Incomplete") {
                this.$emit("changeincomplete-click")
            } else if (action == "Change Complete") {
                this.$emit("changecomplete-click")
            } else if (action == "Close Case") {
                this.$emit("closecase-click")
            } else if (action == "Reject Case") {
                this.$emit("rejectcase-click")
            } else if (action == "Update Status") {
                this.$emit("changeincompletecomplete-click")
            } else if (action == "Skip CE Close Case") {
                this.dialog_skipce = true
            }
        },
        gotoLink(eleId) {
            this.$vuetify.goTo(eleId, this.options)
        },
        open_log_eeg(subcase_id) {
            this.get_log_eeg(subcase_id)
            this.dialog_eeg = true
        },
        async get_log_eeg(subcase_id) {
            this.dialog_loading = true
            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/get-log-eeg/${subcase_id}`,
                    this.tk
                )
                .then((response) => {
                    this.dialog_loading = false
                    // console.log(response.data, "-get-log-eeg")
                    this.data_eeg = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    computed: {
        checkcondition() {
            var team = [
                "TL",
                "Host",
                "Onsite",
                "WFH",
                "Engineer",
                "Onsite - Replace Toner",
                "Product Specialist",
            ]
            var chk = team.includes(localStorage.role_name)

            // condition แบบเก่า
            // if (
            //   localStorage.branch_name == this.detailcase.open_branch_name &&
            //   localStorage.team_name == "SVC" &&
            //   chk === false
            // ) {
            //   return true;
            // } else if (
            //   ((this.detailcase.team_name == localStorage.team_name ||
            //     (localStorage.team_name == "INVENTORY" &&
            //       localStorage.role_name != "Onsite - Replace toner")) &&
            //     chk === false &&
            //     localStorage.team_name != "SVC") ||
            //   (this.detailcase.project_name == localStorage.team_name &&
            //     chk === false)
            // ) {
            //   return true;
            // } else {
            //   return false;
            // }

            // console.log(localStorage.branch_name, "-localStorage.branch_name")
            // console.log(
            //     this.detailcase.open_branch_name,
            //     "-detailcase.open_branch_name"
            // )
            // console.log(this.detailcase.team_name, "-detailcase.team_name")
            // console.log(localStorage.role_name, "-localStorage.role_name")
            // console.log(localStorage.team_name, "-localStorage.team_name")
            // console.log(
            //     this.detailcase.project_name,
            //     "-detailcase.project_name"
            // )
            // console.log(this.detailcase.subs[this.detailcase.subcase - 1], "-1")

            if (
                this.detailcase.team_name == localStorage.team_name &&
                chk === false &&
                (localStorage.branch_name == this.detailcase.open_branch_name ||
                    localStorage.role_name == "Admin Hub")
            ) {
                return true
            } else if (
                localStorage.branch_name == this.detailcase.open_branch_name &&
                localStorage.team_name == "SVC" &&
                chk === false &&
                localStorage.role_name != "Manager"
            ) {
                return true
            } else if (
                this.detailcase.team_name == "NONHP" &&
                localStorage.team_name == "INVENTORY" &&
                chk === false
            ) {
                return true
            } else if (
                this.detailcase.project_name == localStorage.team_name &&
                chk === false
            ) {
                return true
            } else if (
                this.detailcase.open_branch_name == "BENCH RAMA3" &&
                localStorage.team_name == "ODM" &&
                (this.detailcase.subs[this.detailcase.subcase - 1]
                    .branch_name == "ODM" ||
                    this.detailcase.subs[this.detailcase.subcase - 1]
                        .branch_name == "BENCH RAMA3")
            ) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>
<style scoped>
.image-cso {
    height: 100px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
.image-cso-btn {
    margin-top: -10px !important;
    margin-left: -18px !important;
}
.fix-png-a {
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 20px;
}
.fix-x-01 {
    padding-bottom: 10px !important;
    /* margin-top: -5px !important ; */
}
.fix-x-02 {
    font-weight: bold;
    font-size: 24px;
    color: #04ff00d9 !important;
}
.fix-x-03 {
    font-weight: bold;
    font-size: 24px;
    color: #ff4000 !important;
    /* text-shadow: 0 0 20px rgba(192, 109, 159, 0.688),0 0 20px rgba(229, 158, 71, 0.747) !important; */
}
</style>
